<script setup>
import ArrowSquareOutIcon from '@iconify-vue/ph/arrow-square-out';
import { Link } from '@inertiajs/vue3';
import { toString, truncate } from '@js/utils/string';

const {
    text,
    href,
    align = 'left',
    inertia = false,
    target = '_blank',
    maxWidth = null,
    minWidth = null,
    length,
} = defineProps({
    text: {
        type: String,
        required: true,
    },
    href: {
        type: String,
        required: true,
    },
    align: {
        type: String,
        required: false,
    },
    inertia: {
        type: Boolean,
        required: false,
    },
    target: {
        type: String,
        required: false,
    },
    maxWidth: {
        type: Number,
        required: false,
    },
    minWidth: {
        type: Number,
        required: false,
    },
    length: {
        type: Number,
        required: false,
    },
});
</script>

<template v-if="toString(text) !== '' && toString(href) !== ''">
    <div
        class="flex h-full items-center p-4 break-all"
        :class="{
            'justify-start': align === 'left',
            'justify-center text-center': align === 'center',
            'justify-end': align === 'right',
        }"
        :style="{ maxWidth: `${maxWidth}px`, minWidth: `${minWidth}px` }"
    >
        <Link
            v-if="inertia"
            :href="href"
            class="flex w-full items-center text-blue-500"
        >
            <span class="overflow-hidden text-ellipsis">
                {{ text }}
            </span>
        </Link>

        <a v-else :href="href" :target="target" class="w-full text-blue-500">
            <span class="overflow-hidden text-ellipsis">
                <template v-if="length">
                    {{ truncate(toString(text), length) }}
                </template>

                <template v-else>
                    {{ text }}
                </template>
            </span>

            <sup v-if="target === '_blank'" class="ml-1">
                <ArrowSquareOutIcon
                    v-if="target === '_blank'"
                    class="inline size-3"
                />
            </sup>
        </a>
    </div>
</template>
